// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4725":"27baed1c","8540":"27baed1c"}[chunkId] + ".chunk.css";
};